import React, { memo } from "react";

import { useGetLoggedIn, useGetProfileData } from "_common/hooks/auth";

import Presentation from "./presentation";

const component = props => {

	const myProfile  = useGetProfileData ();
	const isLoggedIn = useGetLoggedIn ();

	return (
		<Presentation
			{ ...props }
			isLoggedIn  = { isLoggedIn }
			myProfile   = { myProfile }
		/>
	);
};

export default memo ( component );
